import type { ShortcutShape } from 'Services/SalesManagement/Features/Shortcut/shortcutSlice'
import Theme from 'Util/theme'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import DeleteForeverIcon from '@mui/icons-material/DeleteForever'
import EditIcon from '@mui/icons-material/Edit'
import { Box, IconButton, Link, Typography } from '@mui/material'
import type { FC } from 'react'
import LinesEllipsis from 'react-lines-ellipsis'
import { t } from 'ttag'

const Shortcut: FC<{
  shortcut: ShortcutShape
  handleEdit: () => void
  handleDelete: () => void
  canControl: boolean
}> = ({ shortcut, handleEdit, handleDelete, canControl }) => {
  return (
    <Box display="flex" justifyContent="space-between" mb={2}>
      <Box display="flex" alignItems="flex-start">
        <ChevronRightIcon sx={{ color: Theme.palette.tertiary.main }} />
        <Box display="flex" flexDirection="column">
          <Link href={shortcut.link} target="_blank" rel="noopener">
            <Typography variant="h6" fontWeight={600}>
              {shortcut.title_fi}
            </Typography>
          </Link>
          {shortcut.description_fi && (
            <Typography sx={{ opacity: 0.6 }} component="span" variant="body2" color="text.primary">
              <LinesEllipsis
                text={shortcut.description_fi}
                maxLine="3"
                ellipsis="..."
                trimRight
                basedOn="letters"
              />
            </Typography>
          )}
        </Box>
      </Box>
      {canControl && (
        <Box display="flex" alignItems="flex-start">
          <IconButton onClick={handleEdit} aria-label={t`Edit shortcut`}>
            <EditIcon sx={{ color: Theme.palette.tertiary.main }} />
          </IconButton>
          <IconButton onClick={handleDelete} aria-label={t`Delete shortcut`}>
            <DeleteForeverIcon color="error" />
          </IconButton>
        </Box>
      )}
    </Box>
  )
}

export { Shortcut }
